import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from '@/lib/api-fetch';

interface ValidateAdviserPayload {
  email: string;
}

interface ValidateAdviserResponse {
  isValid: boolean;
  adviserId?: string;
}

/**
 * Thunk to validate if an email address belongs to a known financial adviser
 */
export const validateAdviserThunk = createAsyncThunk<ValidateAdviserResponse, ValidateAdviserPayload>(
  'adviser/validate',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await apiFetch('/api/adviser/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || 'Failed to validate email address');
      }

      const data = await response.json();
      return data as ValidateAdviserResponse;
    } catch {
      return rejectWithValue('Network error: Unable to validate email address');
    }
  }
);
